export default [
  {
    path: '/activity-20250814-main',
    component: () => import('./Page.vue'),
    meta: { expire: '2025-08-20T23:59:59.000+08:00', title: '夏日游园会' },
  },
  {
    path: '/activity-20250814-rule-v2',
    component: () => import('./Rule.vue'),
    meta: { expire: '2025-08-20T23:59:59.000+08:00', title: '夏日游园会-规则说明' },
  },
]
